// API Configuration
// Production: https://pussikuskit.fi/api
// Local: http://127.0.0.1:5000/api

const getApiUrl = () => {
  // If REACT_APP_API_URL is explicitly set, use it (highest priority)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Detect production vs local environment based on hostname
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;
  
  // Preview/test server: use same-origin API at preview.pussikuskit.fi
  if (hostname === 'preview.pussikuskit.fi') {
    const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    return `${baseUrl}/api`;
  }

  // Production: main domain
  if (hostname === 'pussikuskit.fi') {
    return 'https://pussikuskit.fi/api';
  }
  
  // If not localhost/127.0.0.1, assume production and use same origin
  // This handles cases where frontend and backend are on the same domain
  if (hostname !== 'localhost' && hostname !== '127.0.0.1' && !hostname.startsWith('192.168.') && !hostname.startsWith('10.') && !hostname.startsWith('172.')) {
    // Use same protocol and hostname, but assume API is at /api
    const baseUrl = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    return `${baseUrl}/api`;
  }

  // Local development: localhost or 127.0.0.1
  // Use 127.0.0.1 as specified by user (works the same as localhost)
  return 'http://127.0.0.1:5000/api';
};

export const API_URL = getApiUrl();
